export const linkdin = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_153_11130)">
      <path
        d="M19.9951 19.9999V19.999H20.0001V12.664C20.0001 9.07569 19.2276 6.31152 15.0326 6.31152C13.0159 6.31152 11.6626 7.41819 11.1101 8.46736H11.0517V6.64652H7.07422V19.999H11.2159V13.3874C11.2159 11.6465 11.5459 9.96319 13.7017 9.96319C15.8259 9.96319 15.8576 11.9499 15.8576 13.499V19.9999H19.9951Z"
        fill="#3734A9"
      />
      <path
        d="M0.330078 6.64771H4.47675V20.0002H0.330078V6.64771Z"
        fill="#3734A9"
      />
      <path
        d="M2.40167 0C1.07583 0 0 1.07583 0 2.40167C0 3.7275 1.07583 4.82583 2.40167 4.82583C3.7275 4.82583 4.80333 3.7275 4.80333 2.40167C4.8025 1.07583 3.72667 0 2.40167 0V0Z"
        fill="#3734A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_153_11130">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const facebook = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="#3734A9"
  >
    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"  fill="#3734A9"/>
  </svg>
);
export const messenger = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clip-path="url(#clip0_153_11128)">
      <path
        d="M0.986328 9.25917C0.986328 12.1725 2.43966 14.7717 4.71216 16.4692V20L8.11716 18.1317C9.0255 18.3825 9.988 18.5192 10.9855 18.5192C16.508 18.5192 20.9855 14.3742 20.9855 9.26C20.9863 4.14583 16.5088 0 10.9863 0C5.46383 0 0.986328 4.145 0.986328 9.25917H0.986328ZM9.93133 6.66583L12.5397 9.38167L17.4455 6.66583L11.9788 12.4675L9.433 9.7525L4.46383 12.4683L9.93133 6.66583Z"
        fill="#3734A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_153_11128">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.986328)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const twitter = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clip-path="url(#clip0_153_11134)">
      <path
        d="M18.9196 5.9275C19.7329 5.35 20.4171 4.62917 20.9746 3.79917V3.79833C20.2304 4.12417 19.4388 4.34083 18.6121 4.44583C19.4621 3.93833 20.1113 3.14083 20.4163 2.18C19.6238 2.6525 18.7488 2.98583 17.8163 3.1725C17.0638 2.37083 15.9913 1.875 14.8213 1.875C12.5513 1.875 10.7238 3.7175 10.7238 5.97583C10.7238 6.30083 10.7513 6.61333 10.8188 6.91083C7.41044 6.74417 4.39378 5.11083 2.36711 2.62167C2.01378 3.23583 1.80544 3.93833 1.80544 4.69417C1.80544 6.11417 2.53628 7.3725 3.62711 8.10167C2.96794 8.08917 2.32211 7.8975 1.77461 7.59667V7.64167C1.77461 9.63417 3.19544 11.2892 5.05961 11.6708C4.72544 11.7625 4.36211 11.8058 3.98461 11.8058C3.72211 11.8058 3.45711 11.7908 3.20878 11.7358C3.73961 13.3592 5.24794 14.5533 7.03961 14.5925C5.64461 15.6833 3.87294 16.3408 1.95544 16.3408C1.61961 16.3408 1.29711 16.3258 0.974609 16.285C2.79128 17.4558 4.94294 18.125 7.26461 18.125C14.5004 18.125 19.2163 12.0883 18.9196 5.9275Z"
        fill="#3734A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_153_11134">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.974609)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const twoo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clip-path="url(#clip0_153_11136)">
      <path
        d="M9.39081 14.0991C9.44414 14.0541 9.49831 14.0075 9.54831 13.9583C6.76414 16.69 2.22414 15.415 1.15997 11.5625V11.5566C-0.267526 6.31496 5.75164 2.33329 9.54664 5.99996C9.62581 6.08412 14.8683 11.675 14.535 11.3191H14.55C15.3325 12.1258 16.4641 12.0375 17.1375 11.3325C17.8616 10.5758 17.8875 9.34079 17.1766 8.57162C16.0541 7.27912 13.85 8.24496 14.0608 10.1608L12.7991 8.87579L11.3358 7.47662C11.6375 6.87746 12.0333 6.35329 12.5291 5.89996C12.4758 5.94579 12.4216 5.99329 12.3716 6.04079C15.1666 3.29912 19.7033 4.60412 20.76 8.43996V8.44496C22.1908 13.6858 16.165 17.6675 12.3733 14.0008C12.2958 13.9175 7.05664 8.29162 7.38831 8.64829L7.38497 8.63579C7.37164 8.63579 7.37164 8.62329 7.37164 8.62329C6.54997 7.77579 5.43581 7.90329 4.78414 8.59746C4.05914 9.35412 4.03414 10.5891 4.74664 11.3466C5.81997 12.6091 8.07164 11.6733 7.85997 9.71912C7.94164 9.80329 10.7675 12.7041 10.5875 12.52C10.13 13.4325 9.61831 13.8516 9.39081 14.0991Z"
        fill="#3734A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_153_11136">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.960938)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const recapcha = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="50"
    viewBox="0 0 150 50"
    fill="none"
  >
    <path
      d="M104.81 28.67C104.9 28.31 104.56 27.98 104.16 28.03L102.96 28.01C102.49 27.93 102.15 28.32 102.11 28.7L102.21 29.12C101.2 28.18 100.05 27.66 98.3298 27.65C95.1298 27.71 92.4898 30.21 92.5398 33.49C92.5698 36.77 95.0798 39.24 98.4098 39.32C99.8798 39.18 101.17 38.62 102.08 37.71L102.19 43.1C102.14 43.54 102.53 43.83 102.91 43.82L104.15 43.87C104.56 43.82 104.84 43.48 104.84 43.05H104.91C104.78 42.47 104.56 42.26 104.08 42.19L104.11 29.55C104.62 29.64 104.84 29.23 104.9 28.87L104.81 28.67ZM98.3298 37.28C96.1598 37.35 94.4498 35.53 94.5098 33.5C94.4998 31.35 96.2998 29.62 98.3798 29.67C100.38 29.6 102.15 31.3 102.13 33.42C102.13 35.34 100.61 37.28 98.3098 37.26L98.3298 37.28Z"
      fill="#333333"
    />
    <path
      d="M129.239 36.98C129.339 36.69 128.949 36.34 128.569 36.34L128.509 36.39C128.129 36.39 127.689 36.69 127.739 37.09L120.149 37.06L129.349 21.62L129.359 21.7C129.809 20.96 129.439 20.38 128.729 20.4L118.229 20.44C117.659 20.29 117.399 20.76 117.309 21.02L117.409 22.31C117.479 22.77 117.749 23.04 118.249 23.12L118.279 23.08C118.759 23.14 118.979 22.72 119.109 22.44L126.639 22.38L117.299 37.71L117.459 37.8C116.969 38.49 117.229 39 118.019 39.05L128.659 39.1C128.899 38.95 129.339 38.62 129.279 38.18L129.239 36.98Z"
      fill="#333333"
    />
    <path
      d="M49.7398 27.65C48.0798 27.56 46.8098 28.11 45.8098 29L45.9098 21.23C45.9098 20.84 45.5898 20.41 45.1398 20.46L43.8898 20.37C43.4798 20.33 43.1698 20.8 43.0898 21.1L43.1698 21.29C43.0898 21.59 43.5598 22.06 43.8598 21.98L43.9398 37.39C43.6398 37.47 43.1698 37.7 43.2498 38.24L43.2198 38.27C43.0898 38.6 43.5598 39 43.8598 38.92L45.1298 39.04C45.5398 38.95 45.8698 38.69 45.8198 38.18V37.73C46.6998 38.5 48.2098 39.24 49.6398 39.17C53.0198 39.33 55.4898 36.69 55.5798 33.52C55.4798 30.2 52.9398 27.63 49.6998 27.61L49.7398 27.65ZM49.7498 37.32C47.8698 37.36 45.8698 35.78 45.9498 33.51C45.9498 31.66 47.2998 29.59 49.7998 29.67C51.8198 29.63 53.5998 31.3 53.6398 33.48C53.6198 35.51 51.8498 37.28 49.7298 37.3L49.7498 37.32Z"
      fill="#111111"
    />
    <path
      d="M26.4597 27.65C25.7897 27.64 24.8197 27.8 24.1097 28.38C23.7797 27.98 23.6297 27.98 23.2897 27.88L22.1997 27.94C21.7097 27.91 21.4997 28.25 21.4297 28.64L21.4497 28.77C21.4397 29.17 21.7397 29.59 22.1397 29.52L22.2097 37.4C21.8797 37.45 21.4597 37.7 21.5297 38.22L21.4597 38.23C21.4297 38.65 21.8097 39 22.1597 38.96L24.1597 39C24.5897 39.01 24.8897 38.69 24.9097 38.24L24.9197 38.19C24.8997 37.75 24.5797 37.42 24.1997 37.4L24.2397 32.11C24.2997 30.39 25.4197 29.55 26.4997 29.58H27.2297C27.5997 29.59 27.8697 29.16 27.9097 28.86L27.8197 28.31C27.8597 27.96 27.5197 27.59 27.0897 27.58L26.4597 27.65Z"
      fill="#111111"
    />
    <path d="M4 48C83 26 82 33 136 20" stroke="#777777" />
    <path d="M4 22C61 20 65 39 134 36" stroke="#888888" />
    <path
      d="M74.3809 27.65C72.7309 27.65 71.4109 28.29 70.4909 29.05L70.4809 28.72C70.5109 28.34 70.2209 27.98 69.7809 27.99H68.5909C68.2809 28.07 67.8109 28.25 67.9009 28.8L67.7509 28.76C67.8209 29.25 68.1909 29.59 68.5909 29.6L68.6709 42.35C68.0909 42.16 67.8109 42.53 67.7109 42.93L67.8309 43.08C67.8409 43.59 68.1909 43.83 68.6109 43.87L70.5509 43.88C70.9509 43.82 71.2709 43.55 71.2609 43.05L71.3209 43.07C71.3109 42.57 70.9509 42.26 70.5709 42.29L70.4709 37.71C71.6009 38.7 72.7809 39.24 74.4709 39.33C77.5109 39.15 80.2009 36.69 80.1009 33.34C80.2809 30.3 77.6109 27.66 74.4709 27.75L74.3809 27.65ZM74.4709 37.37C72.1609 37.34 70.5409 35.36 70.5909 33.49C70.5309 31.3 72.2509 29.62 74.3809 29.62C76.3609 29.56 78.2309 31.3 78.1809 33.38C78.1409 35.44 76.5909 37.28 74.2909 37.19L74.4709 37.37Z"
      fill="#222222"
    />
    <path d="M5 23C76 15 94 5 136 16" stroke="#444444" />
    <path d="M2 16C61 45 57 15 142 28" stroke="#666666" />
  </svg>
);
export const reload = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M19.295 12C19.388 11.9999 19.48 12.0181 19.5659 12.0538C19.6518 12.0894 19.7297 12.1417 19.7952 12.2076C19.8608 12.2735 19.9126 12.3518 19.9478 12.4378C19.9829 12.5239 20.0007 12.616 20 12.709V15.913C20.0007 16.0055 19.9831 16.0973 19.9482 16.183C19.9134 16.2688 19.862 16.3468 19.797 16.4126C19.732 16.4785 19.6546 16.5309 19.5694 16.5668C19.4841 16.6027 19.3926 16.6215 19.3 16.622C19.2075 16.6215 19.116 16.6027 19.0307 16.5668C18.9454 16.5309 18.868 16.4785 18.803 16.4126C18.738 16.3468 18.6866 16.2688 18.6518 16.183C18.6169 16.0973 18.5994 16.0055 18.6 15.913V14.788C16.779 17.844 13.399 20 9.75702 20C5.34702 20 1.65102 17.279 0.0480178 13.085C-0.0192879 12.9103 -0.0150476 12.716 0.0598204 12.5444C0.134688 12.3728 0.274156 12.2375 0.448018 12.168C0.808018 12.027 1.21402 12.208 1.35402 12.573C2.75402 16.235 5.94202 18.583 9.75702 18.583C13.128 18.583 16.277 16.401 17.744 13.429L16.273 13.439C16.1805 13.4391 16.0888 13.421 16.0033 13.3857C15.9178 13.3504 15.84 13.2985 15.7746 13.2332C15.7091 13.1678 15.6571 13.0901 15.6217 13.0046C15.5863 12.9192 15.568 12.8275 15.568 12.735C15.5656 12.5482 15.6375 12.3681 15.7678 12.2342C15.8981 12.1003 16.0762 12.0236 16.263 12.021L19.295 12ZM10.245 0C14.653 0 18.35 2.721 19.953 6.915C20.0203 7.08974 20.0161 7.28396 19.9412 7.45559C19.8663 7.62723 19.7269 7.76246 19.553 7.832C19.467 7.86555 19.3752 7.88167 19.2829 7.87943C19.1906 7.87719 19.0996 7.85663 19.0153 7.81895C18.931 7.78127 18.8551 7.72722 18.7918 7.65993C18.7286 7.59265 18.6794 7.51347 18.647 7.427C17.247 3.765 14.059 1.417 10.244 1.417C6.87302 1.417 3.72402 3.599 2.25702 6.571L3.72802 6.561C3.82055 6.56087 3.91221 6.57898 3.99773 6.6143C4.08326 6.64962 4.16099 6.70146 4.22647 6.76684C4.29195 6.83223 4.34389 6.90988 4.37933 6.99536C4.41478 7.08084 4.43302 7.17246 4.43302 7.265C4.43542 7.45181 4.36358 7.63194 4.23326 7.76581C4.10295 7.89969 3.92483 7.97637 3.73802 7.979L0.705018 8C0.612061 8.00013 0.519998 7.98186 0.434141 7.94623C0.348285 7.91059 0.270335 7.85831 0.204791 7.79239C0.139246 7.72648 0.0874051 7.64823 0.0522589 7.56218C0.0171127 7.47612 -0.000642541 7.38395 1.77626e-05 7.291V4.087C1.77626e-05 3.695 0.313018 3.378 0.700018 3.378C1.08602 3.378 1.40002 3.695 1.40002 4.087V5.212C3.22102 2.156 6.60102 0 10.243 0H10.245Z"
      fill="black"
    />
  </svg>
);
export const contactbg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="491"
    height="623"
    viewBox="0 0 491 623"
    fill="none"
  >
    <path
      d="M0 10C0 4.47716 4.47715 0 10 0H481C486.523 0 491 4.47715 491 10V624C491 629.523 486.523 634 481 634H10C4.47716 634 0 629.523 0 624V10Z"
      fill="#181066"
    />
  </svg>
);
export const quote = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="29.5" fill="white" stroke="#E8EDEF" />
    <path
      d="M38.125 21.75C39.1406 21.75 40 22.6094 40 23.625V33C40 36.4766 37.1875 39.25 33.75 39.25H33.4375C32.8906 39.25 32.5 38.8594 32.5 38.3125V36.4375C32.5 35.9297 32.8906 35.5 33.4375 35.5H33.75C35.1172 35.5 36.25 34.4062 36.25 33V30.5H33.125C32.0703 30.5 31.25 29.6797 31.25 28.625V23.625C31.25 22.6094 32.0703 21.75 33.125 21.75H38.125ZM26.875 21.75C27.8906 21.75 28.75 22.6094 28.75 23.625V33C28.75 36.4766 25.9375 39.25 22.5 39.25H22.1875C21.6406 39.25 21.25 38.8594 21.25 38.3125V36.4375C21.25 35.9297 21.6406 35.5 22.1875 35.5H22.5C23.8672 35.5 25 34.4062 25 33V30.5H21.875C20.8203 30.5 20 29.6797 20 28.625V23.625C20 22.6094 20.8203 21.75 21.875 21.75H26.875Z"
      fill="#181066"
    />
  </svg>
);
